import client from "./client";

const OPTIMIZER_BASE_PATH = "/api/v1/optimizer";

// Start an optimization job (proxied to the optimizer microservice by the backend).
export async function startOptimization(payload) {
  const res = await client.post(`${OPTIMIZER_BASE_PATH}/jobs`, payload);
  return res.data; // { job_id, status }
}

// Poll a job's status (fallback when the SSE stream drops + to fetch the final result).
export async function getOptimizationStatus(jobId) {
  const res = await client.get(`${OPTIMIZER_BASE_PATH}/jobs/${jobId}`);
  return res.data;
}

// Path of the SSE progress stream (consumed via EventSource).
export function optimizerEventsPath(jobId) {
  return `${OPTIMIZER_BASE_PATH}/jobs/${jobId}/events`;
}
